import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import { Link } from 'react-router-dom';
import { Field, FieldArray, reduxForm, SubmissionError } from "redux-form";
import LoadingProgress from '../components/LoadingProgress'

import Box from "../components/Box";
import ErrorMessage from "../components/ErrorMessage";
import { fetchMachine, updateMachine } from "../actions/machines";
import {
  renderInputField,
  renderSelectField,
  renderTextAreaField,
} from "../utils/forms";

class MachineEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loaded: false, activeTab: 'general' };
    this.submit = this.submit.bind(this);
    this.setTab = this.setTab.bind(this);
  }

  setTab(tab) {
    this.setState({ activeTab: tab });
  }

  componentDidMount() {
    const { machines, fetchMachine, match } = this.props;

    if (!machines.machine) {
      fetchMachine(match.params.id);
    } else {
      this.setState({ loaded: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.machines.machine) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {
    const { updateMachine, match } = this.props;

    props.Executor = this.props.fullname;

    return updateMachine(match.params.id, props).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  renderPairingSecurity(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Número de serie</th>
                <th scope="col">PIN</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((securitylocker, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${securitylocker}.Type`}
                      component={renderSelectField}
                    >
                      <option value="">Selecciona un tipo...</option>
                      <option value="COINBOX">COINBOX</option>
                      <option value="BILLBOX">BILLBOX</option>
                      <option value="CHANGEBOX">CHANGEBOX</option>
                      <option value="SAFETYBOX">SAFETYBOX</option>
                      <option value="KIOSKDOOR">PUERTA KIOSKO</option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${securitylocker}.SN`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${securitylocker}.Pin`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  renderLanguages(props) {
    const { fields } = props;

    let languageCounter = 0;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <tbody>
              {fields.map((registerlanguage, index) => (
                <tr key={index}>
                  <td>{languageCounter++ + 1}</td>
                  <td>
                    <Field
                      name={`${registerlanguage}.Language`}
                      component={renderSelectField}
                    >
                      <option value="">Selecciona un idioma...</option>
                      <option value="es_ES">ESPAÑOL</option>
                      <option value="en_EN">ENGLISH</option>
                      <option value="fr_FR">FRANÇAIS</option>
                      <option value="it_IT">ITALIANO</option>
                      <option value="gr_GR">DEUTSCH</option>
                      <option value="cz_CZ">ČEŠTINA</option>
                      <option value="cat_CAT">CATALÀ</option>
                      <option value="pt_PT">PORTUGUESE</option>
                      <option value="nw_NW">NORSK</option>
                      <option value="nl_NL">NEDERLAND</option>
                    </Field>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {languageCounter < 3 && (
          <div className="text-right">
            <button
              className="btn bg-vw-light text-white"
              type="button"
              onClick={() => fields.push({})}
            >
              <i className="fas fa-plus mr-1"></i>
              Añadir
            </button>
          </div>
        )}
      </div>
    );
  }

  renderModules(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Número de serie</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((module, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${module}.serialNumber`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  renderPaymentDevices(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Dispositivo</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((device, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${device}.Type`}
                      component={renderSelectField}
                      label="Tipo"
                    >
                      <option value="">Selecciona un tipo...</option>
                      <option value="TPV">TPV</option>
                      <option value="CASH">CASH</option>
                      <option value="SCANNER">SCANNER</option>
                      <option value="SECURITY">SEGURIDAD</option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${device}.Device`}
                      component={renderSelectField}
                      label="Dispositivo"
                    >
                      <option value="">Selecciona un dispositivo...</option>
                      <option value="PAYTEF">PAYTEF</option>
                      <option value="SPIRE">SPIRE</option>
                      <option value="U1000">U1000</option>
                      <option value="Q5000">Q5000</option>
                      <option value="Q6000">Q6000</option>
                      <option value="NV9USB">NV9USB</option>
                      <option value="COINCO">COINCO</option>
                      <option value="NAYAX">NAYAX</option>
                      <option value="HOPPER">HOPPER</option>
                      <option value="D2S">D2S</option>
                      <option value="SCANNER">QR/RFID SCANNER</option>
                      <option value="SOLENOID">SOLENOIDES</option>
                    </Field>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { machines, error, pristine, submitting, handleSubmit } = this.props;

    if (!this.state.loaded) {
      if (machines.error) {
        return <ErrorMessage message={machines.error.message} />;
      }
      return <LoadingProgress />;
    }

    const machine = machines.machine;
    const { activeTab } = this.state;

    return (
      <div className="machines-admin-view">
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-edit mr-2"></i>Editar
                <span className="ml-2 text-vw-dark">{machine.Serial}</span>
              </h1>
            </div>
            <div className="header-actions">
              <Link to={`/machines/${machine._id}`} className="mach-admin-btn secondary">
                <i className="fas fa-arrow-left"></i>
                <span className="d-none d-sm-inline">Volver</span>
              </Link>
              <button
                className="mach-admin-btn"
                style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)', color: 'white' }}
                type="button"
                disabled={pristine || submitting}
                onClick={handleSubmit(this.submit)}
              >
                <i className="fas fa-save"></i>
                <span className="d-none d-sm-inline">{submitting ? 'Guardando...' : 'Guardar'}</span>
              </button>
            </div>
          </div>
        </div>

        <div className="od-page-nav">
          {[
            { id: 'general',   icon: 'fa-cogs',       label: 'General' },
            { id: 'idiomas',   icon: 'fa-globe',       label: 'Idiomas' },
            { id: 'operativa', icon: 'fa-lock',        label: 'Operativa' },
            { id: 'pagos',     icon: 'fa-credit-card', label: 'Pagos' },
            { id: 'modulos',   icon: 'fa-cubes',       label: 'Modulos' },
          ].map(t => (
            <button
              key={t.id}
              type="button"
              className={`od-page-tab${activeTab === t.id ? ' active' : ''}`}
              onClick={() => this.setTab(t.id)}
            >
              <i className={`fas ${t.icon}`}></i>
              <span>{t.label}</span>
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit(this.submit)}>

          {/* === TAB: GENERAL === */}
          {activeTab === 'general' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-3">
                  <Box title="Maquina" icon="cubes">
                    <Field name="OldLocker" component={renderSelectField} label="Locker Antiguo">
                      <option value="">Tiene instalados lockers antiguos?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="GenderMode" component={renderSelectField} label="Vestuarios">
                      <option value="">Tienes taquillas en vestuarios no mixtos?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="LockersFirmwareVersion" component={renderSelectField} label="Firmware nuevo">
                      <option value="">Se ha hecho OTA con firmware nuevo?</option>
                      <option value="0">No</option>
                      <option value="1">Si</option>
                    </Field>
                    <Field name="PrinterSensorActive" component={renderSelectField} label="Aviso de ticket">
                      <option value="">Habilitar aviso de ticket?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="StartPassRecovery" component={renderSelectField} label="Recuperacion Password Start">
                      <option value="">Habilitar la recuperacion en Start?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="LedStatusIndicator" component={renderSelectField} label="Indicador LED">
                      <option value="">Habilitar el indicador LED?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="UndefinedLockerRental" component={renderSelectField} label="Bloqueo alquiler">
                      <option value="">Habilitar el bloqueo del alquiler?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="RedeemCode" component={renderSelectField} label="Codigos de canje">
                      <option value="">Habilitar los codigos de canje?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="SolenoidDoor" component={renderSelectField} label="Apertura por solenoide">
                      <option value="">Habilitar apertura por solenoide?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Interficie" icon="desktop">
                    <Field name="GeneralSoundActive" component={renderSelectField} label="Pasos sonoros">
                      <option value="">Habilitar pasos sonoros?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="Sound_interval" type="text" component={renderInputField} label="Intervalo sonido burbujas" />
                    <div style={{ border: '1px solid #5bc0de', borderRadius: 4, padding: '8px 10px 4px', backgroundColor: '#f0f9ff', marginBottom: 12 }}>
                      <span className="badge badge-info" style={{ marginBottom: 8, display: 'block', whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.8' }}><i className="fa fa-info-circle" /> Si la máquina funciona con reserva anticipada, el inicio del sleep mínimo después de las 02:00</span>
                      <Field name="SleepStart" type="text" component={renderInputField} label="Inicio del modo sleep (h)" />
                      <Field name="SleepEnd" type="text" component={renderInputField} label="Fin del modo sleep (h)" />
                    </div>
                    <Field name="PaymentMethods" component={renderSelectField} label="Metodos de pago">
                      <option value="">Selecciona una combinacion...</option>
                      <option value="0">TODOS</option>
                      <option value="1">SOLO CASH</option>
                      <option value="2">SOLO TPV</option>
                      <option value="3">SOLO SCANNER</option>
                      <option value="4">GRATIS</option>
                    </Field>
                    <Field name="BlockU1000Cancelling" component={renderSelectField} label="Bloqueo Cancelar U1000">
                      <option value="">Bloquear cancelacion U1000?</option>
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </Field>
                    <Field name="AutoScreenExitTime" type="text" component={renderInputField} label="Timeout pantallas" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Passwords" icon="unlock">
                    <Field name="PasswordMachine" component={renderInputField} type="text" label="Pin Maquina" />
                    <Field name="PasswordFund" component={renderInputField} type="text" label="Pin Cash" />
                    <Field name="PasswordCash" component={renderInputField} type="text" label="Pin Universal" />
                    <Field name="PasswordMaster" component={renderInputField} type="text" label="Pin Master" />
                    <Field name="PasswordQC" component={renderInputField} type="text" label="Pin QC" />
                  </Box>
                  <Box title="Tarjeta Maestra" icon="id-card">
                    <Field name="MasterUuid" type="text" component={renderInputField} label="UID tarjeta maestra" />
                    {/* form-text/text-muted y no help-block: help-block es de Bootstrap 3 y
                        en este proyecto (Bootstrap 4) no tiene ningun estilo, asi que la
                        nota salia al tamaño del cuerpo y en negro. */}
                    <small className="form-text text-muted" style={{ marginTop: -6 }}>
                      Solo en modo RFID · 8 o 14 caracteres hex. Tras guardar, lanza la acción
                      remota <b>Set Master Key</b> para grabarlo en las cerraduras.
                    </small>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Acceso Rapido" icon="wifi">
                    <Field name="QuickAccessMode" component={renderSelectField} label="Acceso rapido">
                      <option value="PIN">PIN</option>
                      <option value="RFID">Pulsera RFID</option>
                    </Field>
                  </Box>
                  <Box title="Otros" icon="comments">
                    <Field name="standbyPhrase" type="text" component={renderTextAreaField} label="Frase Standby" />
                    <Field name="Contacto" type="text" component={renderInputField} label="Telefono de incidencias" />
                    <Field name="Report_email" type="text" component={renderInputField} label="E-mail de reportes" />
                    <Field name="Comments" type="text" component={renderTextAreaField} label="Comentarios" />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: IDIOMAS === */}
          {activeTab === 'idiomas' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <Box title="Idioma Principal" icon="globe">
                    <Field name="Language" component={renderSelectField} label="Idioma principal">
                      <option value="">Selecciona un idioma...</option>
                      <option value="es_ES">ESPANOL</option>
                      <option value="en_EN">ENGLISH</option>
                      <option value="fr_FR">FRANCAIS</option>
                      <option value="it_IT">ITALIANO</option>
                      <option value="gr_GR">DEUTSCH</option>
                      <option value="cz_CZ">CESTINA</option>
                      <option value="cat_CAT">CATALA</option>
                      <option value="pt_PT">PORTUGUESE</option>
                      <option value="nw_NW">NORSK</option>
                      <option value="nl_NL">NEDERLAND</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-6">
                  <Box title="Idiomas Adicionales" icon="language">
                    <FieldArray name="SupportedLanguages" component={this.renderLanguages} />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: OPERATIVA === */}
          {activeTab === 'operativa' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-2">
                  <Box title="Day Scan" icon="comments">
                    <Field name="ScanDayAllowed" component={renderSelectField} label="Day Scan activo?">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                    <Field name="ScanDayInterval" type="text" component={renderInputField} label="Day Scan Interval" />
                    <Field name="PassOpens" type="text" component={renderInputField} label="Num. de aperturas" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="QR" icon="comments">
                    <Field name="QRActive" component={renderSelectField} label="Venta QR Habilitada">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                    <Field name="QRPercentage" type="text" component={renderInputField} label="Porcentaje de reserva" />
                    <Field name="QRMode" component={renderSelectField} label="Modo de funcionamiento">
                      <option value="">Selecciona un modo...</option>
                      <option value="0">MTO DIARIO</option>
                      <option value="1">OTO DIARIO SIN PIN</option>
                      <option value="2">OTO DIARIO CON PIN</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="Reserva" icon="comments">
                    <Field name="BookActive" component={renderSelectField} label="Reserva habilitada">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                    <Field name="BookPercentage" type="text" component={renderInputField} label="Porcentaje de reserva" />
                    <Field name="BookFreeTime" type="text" component={renderInputField} label="Hora de liberacion" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="Limpieza" icon="comments">
                    <Field name="CleanActive" component={renderSelectField} label="Limpieza Habilitada">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                    <Field name="CleanAll" component={renderSelectField} label="Limpiar Siempre">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="Configuracion" icon="lock">
                    <Field name="ScanNightAllowed" component={renderSelectField} label="Night Scan activo">
                      <option value="true">SI</option>
                      <option value="false">NO</option>
                    </Field>
                    <Field name="AlarmDefault" component={renderSelectField} label="Alarma locker abierto">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                    <Field name="BuzzerDefault" component={renderSelectField} label="Sonido teclado activo">
                      <option value="1">SI</option>
                      <option value="0">NO</option>
                    </Field>
                    <Field name="OpenModeDefault" component={renderSelectField} label="Cierre manual">
                      <option value="false">NO</option>
                      <option value="true">SI</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="Firmware Nuevo" icon="lock">
                    <Field name="PasswordLength" component={renderSelectField} label="Caract. Contrasena">
                      <option value="4">4</option>
                      <option value="6">6</option>
                    </Field>
                    <Field name="BLEPower" component={renderSelectField} label="Potencia BLE (dB)">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Field>
                    <Field name="BLEAdvTime" component={renderSelectField} label="Cadencia BLE (ms)">
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </Field>
                    <Field name="Keypad" component={renderSelectField} label="Encender Teclado">
                      <option value="0">NO</option>
                      <option value="1">SI</option>
                    </Field>
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: PAGOS === */}
          {activeTab === 'pagos' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-3">
                  <Box title="Dispositivos">
                    <FieldArray name="PaymentDevices" component={this.renderPaymentDevices} />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="TPV" icon="credit-card">
                    <Field name="Tpv_serial" type="text" component={renderInputField} label="Num. de serie" />
                    <Field name="Tpv_max" type="text" component={renderInputField} label="Cargo maximo (EUR)" />
                    <Field name="TpvCancelTime" type="text" component={renderInputField} label="Timeout de cancelacion" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="PAYTEF" icon="credit-card">
                    <Field name="Tpv_tcod" type="text" component={renderInputField} label="TCOD" />
                  </Box>
                  <Box title="REDSYS" icon="credit-card">
                    <Field name="TpvBusinessCode" type="text" component={renderInputField} label="Codigo de comercio" />
                    <Field name="TpvTerminalCode" type="text" component={renderInputField} label="Num. de Terminal" />
                    <Field name="TpvFirmKeyCode" type="text" component={renderInputField} label="Clave de Firma" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="CASH" icon="coins">
                    <Field name="CashMax" type="text" component={renderInputField} label="Cobro maximo en Cash (EUR)" />
                    <Field name="BillerAcceptance" component={renderSelectField} label="Billetes aceptados">
                      <option value="1111">TODOS 5 / 10 / 20 / 50 EUR</option>
                      <option value="0111">5 / 10 / 20 EUR</option>
                      <option value="0011">5 / 10 EUR</option>
                      <option value="0001">5 EUR</option>
                      <option value="0000">NINGUNO</option>
                    </Field>
                    <Field name="CoinAcceptance" component={renderSelectField} label="Monedas aceptadas">
                      <option value="0">0,50 EUR</option>
                      <option value="1">1 EUR</option>
                      <option value="2">2 EUR</option>
                      <option value="3">1 EUR / 2 EUR</option>
                    </Field>
                    <Field name="FixedChangeInitial" component={renderSelectField} label="Fondo de caja fijo">
                      <option value="true">SI</option>
                      <option value="false">NO</option>
                    </Field>
                    <Field name="ChangeInitial" type="text" component={renderInputField} label="Fondo de caja (EUR)" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-2">
                  <Box title="Devoluciones" icon="coins">
                    <Field name="LimiteDevolucionDiario" type="text" component={renderInputField} label="Max devolucion diario (EUR)" />
                    <Field name="LimiteDevolucion" type="text" component={renderInputField} label="Max devolucion de una sola vez (EUR)" />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: MODULOS === */}
          {activeTab === 'modulos' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <Box title="Modulos">
                    <FieldArray name="Modules" component={this.renderModules} />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-6">
                  <Box title="Seguridad">
                    <FieldArray name="SecurityLockers" component={this.renderPairingSecurity} />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {error && <div className="alert alert-danger">{error}</div>}
        </form>
      </div>
    );
  }
}

MachineEditForm = reduxForm({
  form: "MachineEditForm",
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/machines`);
  },
})(MachineEditForm);

const mapStateToProps = (state) => {
  let Build_date = null;

  if (state.machines.machine) {
    Build_date = state.machines.machine.Build_date;
  }

  return {
    machines: state.machines,
    fullname: state.auth.fullname,
    initialValues: {
      ...state.machines.machine,
      Build_date: new Date(Build_date).toISOString().substring(0, 10),
      BuzzerDefault: (state.machines.machine?.BuzzerDefault === "1" || state.machines.machine?.BuzzerDefault === 1 || state.machines.machine?.BuzzerDefault === true) ? "1" : "0",
      QuickAccessMode: state.machines.machine?.QuickAccessMode || "PIN",
      MasterUuid: state.machines.machine?.MasterUuid || "",
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMachine: bindActionCreators(fetchMachine, dispatch),
  updateMachine: bindActionCreators(updateMachine, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineEditForm);
